module.exports = __webpack_public_path__ + "img/gian-indigo.39289962.png";